import { render, staticRenderFns } from "./GlobalInputSwitch.vue?vue&type=template&id=4bb2211a&scoped=true&"
import script from "./GlobalInputSwitch.vue?vue&type=script&lang=js&"
export * from "./GlobalInputSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb2211a",
  null
  
)

export default component.exports